import { Injector } from "@angular/core";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { ScientificProductsEntity } from "../../../Data/MedicinalProductData/ScientificProductsEntity";
import { TreeNodeMedicinalProductsAbstractCompositions } from "../ListEntity/TreeNodeMedicinalProductsAbstractCompositions";
import { AbstractStrengthsAutoUploadList } from "./AbstractStrengthsAutoUploadList";
import { AbstractFormulationsAutoUploadList } from "./AbstractFormulationsAutoUploadList";
import { environment } from "../../../../../../environments/environment";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";


export class AbstractCompositionsAutoUploadEntity extends OnDemandAutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string,  parent: BaseNode,model: any, useHist: boolean, disableAutoUpload:boolean, cloningNode: boolean) {
        super(injector, 
            labelTemplate, 
            ScientificProductsEntity, 
            AutoUploadEntityEnum.abstractCompositions, 
            ServiceEnum.MedicinalProducts, 
            parent, 
            model, 
            TreeNodeMedicinalProductsAbstractCompositions,
            true, 
            disableAutoUpload,
            cloningNode,
            {});
            this.useHist = useHist;
    }

    override postLoadEntity(model: any): void {

        this.children?.push(new AbstractStrengthsAutoUploadList(this.ioc!,'Abstract Strengths',model.id, false, false, false));
        this.children?.push(new AbstractFormulationsAutoUploadList(this.ioc!,'Abstract Formulations',model.id, false, false, false));
    }

    public getListItem(): any[] {
        return [this.data.model.scientificname];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: AbstractCompositionsAutoUploadEntity = new AbstractCompositionsAutoUploadEntity(this.ioc!, this.labelTemplate,newParent,this.data.model,this.useHist,this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }

    override getOnDemandEntities() {
        const onDemandEntities: any = super.getOnDemandEntities();
        if (Array.isArray(onDemandEntities ) || Object.keys(onDemandEntities ).length !== 0) {
            return {...this.datasource, ...onDemandEntities};
        }
        return {...this.datasource};
    }
}